import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Collapse, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { ChevronDown, ChevronRight } from 'react-bootstrap-icons';
import {
  dashboardSelector,
  updateListViewItemsStatus,
  updateSelectedMenu,
} from '../features/dashboardSlice';
import { LoggedUserType, SubmenuItemType } from '../utils/Types';
import { loginSelector } from '../features/loginSlice';
import { LIST_VIEW_ITEM } from '../utils/Constant';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';

const SubMenu = (props: any) => {
  const [collapsed, setCollapsed] = useState(true);
  const toggle = () => setCollapsed(!collapsed);
  const { icon, title, items, parentKey, onSelected } = props;
  const dashboardState = useAppSelector(dashboardSelector);
  const dispatch = useAppDispatch();
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  useEffect(() => {
    if (dashboardState.selectedMenu && items) {
      for (const element of items) {
        if (element.route === dashboardState.selectedMenu) {
          setCollapsed(false);
          break;
        }
      }
    }
  }, [dashboardState.selectedMenu]);

  return (
    <div>
      <NavItem
        key={parentKey}
        onClick={toggle}
        className={classNames({ 'menu-open': !collapsed })}
      >
        <NavLink className="clearfix">
          <Image src={icon} alt="icon" className="icon" />
          {title}
          {collapsed ? (
            <ChevronRight className="drop-down-icon float-end" />
          ) : (
            <ChevronDown className="drop-down-icon float-end" />
          )}
        </NavLink>
      </NavItem>
      <Collapse
        isOpen={!collapsed}
        navbar
        className={classNames('items-menu', { 'mb-1': !collapsed })}
      >
        {items.map((submenuItem: SubmenuItemType, index: number) => (
          <Fragment key={`fragment-${parentKey}-${index}`}>
            {submenuItem.roles && submenuItem.roles.includes(user.roleId) && (
              <NavItem
                key={`${parentKey}-${index}`}
                className="pl-4 nav-item-submenu"
              >
                <NavLink
                  tag={Link}
                  to={submenuItem.route}
                  className={`align-middle ${
                    dashboardState.selectedMenu === submenuItem.route
                      ? 'nav-selected'
                      : 'nav-unselected'
                  }`}
                  onClick={() => {
                    if (
                      submenuItem.route === 'view-task' ||
                      submenuItem.route === 'view-lead'
                    ) {
                      dispatch(
                        updateListViewItemsStatus(LIST_VIEW_ITEM.LIST_ITEMS)
                      );
                    }
                    dispatch(updateSelectedMenu(submenuItem.route));
                    onSelected();
                  }}
                >
                  {submenuItem.title}
                </NavLink>
              </NavItem>
            )}
          </Fragment>
        ))}
      </Collapse>
    </div>
  );
};

export default SubMenu;
